import { getSurroundFinishProfile } from '../../../helpers/finish-profiles';
import { PanelItem } from '../panel-item.class';

/**
 * Gap the panel item's finish family leaves between the panel's bottom edge and the item.
 * Only MOK fridges have one today; everything else sits flush. Not applied to a full-height item, whose cutout spans the whole panel by definition.
 * @param panelItem instance of PanelItem
 * @returns reveal in inches, 0 when the item sits flush on the bottom edge
 */
export const getBottomRevealCfn = (panelItem: PanelItem): number => {
	const { item, refMap } = panelItem;
	if (!item?.category?.isFridge) return 0;

	const { fridgeBottomReveal = 0 } = getSurroundFinishProfile(refMap?.island?.surround?.material) ?? {};

	return fridgeBottomReveal;
};
